exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".textboxContainer{z-index:2;position:absolute;bottom:0;right:0;left:0;margin:0 16px 16px;display:inline-block}.textbox{width:99%;height:224px;background:rgba(0,0,0,.8);border:6px solid #55614e;color:#fff;border-radius:0 30px 0 30px;font-family:Fjalla One,sans-serif;float:left;font-size:32px;text-align:left}@media screen and (max-width:900px){.textbox{font-size:24px}}@media screen and (max-width:600px){.textbox{font-size:18px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/TextWindow/styles.sass
// module id = 121
// module chunks = 0